export const COMMENTS_DEFAULT_SORT = 'newest' as const;

export const COMMENTS_SKELETON_COUNT = 5;
